import { Text } from '@vkontakte/vkui';

export function StatTile({
  label,
  value,
  hint,
  accent = 'purple',
}: {
  label: string;
  value: number | string;
  hint?: string;
  accent?: 'purple' | 'green' | 'amber' | 'blue';
}) {
  return (
    <div className={`pb-stat-tile pb-stat-tile--${accent}`}>
      <Text className="pb-stat-tile__value">{value}</Text>
      <Text className="pb-stat-tile__label">{label}</Text>
      {hint && <Text className="pb-stat-tile__hint">{hint}</Text>}
    </div>
  );
}
